import React, { useState } from "react";
import { CustomAccordion } from "../components";
import { BusinessUnitChartYearOverYear, CountryChartYearOverYear, EstimatesChartYearOverYear, RegionChartYearOverYear, RenewableNonRenewableChartYearOverYear, ScopeChartYearOverYear, SiteChartYearOverYear, UtilityTypeChartYearOverYear } from "../../charts";
import { DropdownProps } from "../types";

const YearOverYearDropdown = ({ searchFilters, subTypeChart, currentMainTab }: DropdownProps) => {
  const [yoYLength, setYoYLength] = useState<number>(1);
  const yoYMaxLength: number = 10;

  return <CustomAccordion
    titleAccordion="Year over Year"
    yoYMaxLength={yoYMaxLength}
    setYoYLength={setYoYLength}
    panelNumber={3}
    allowYears
  >
    <ScopeChartYearOverYear
      chartTitle="Scope"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      yoyLengthFilter={yoYLength}
    />
    {(currentMainTab === "Consumption" || currentMainTab === "Financials")
      && <RenewableNonRenewableChartYearOverYear
        chartTitle="Renewable vs. Non-Renewable"
        currentMainTab={currentMainTab}
        searchFilters={searchFilters}
        yoyLengthFilter={yoYLength}
      />
    }
    <UtilityTypeChartYearOverYear
      chartTitle="Utility Type"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      yoyLengthFilter={yoYLength}
    />
    <BusinessUnitChartYearOverYear
      chartTitle="Business Unit"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      yoyLengthFilter={yoYLength}
    />
    <RegionChartYearOverYear
      chartTitle="Region"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      yoyLengthFilter={yoYLength}
    />
    <CountryChartYearOverYear
      chartTitle="Country"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      yoyLengthFilter={yoYLength}
    />
    <SiteChartYearOverYear
      chartTitle="Site"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      yoyLengthFilter={yoYLength}
    />
    <EstimatesChartYearOverYear
      chartTitle="Estimates"
      subTabName={subTypeChart}
      currentMainTab={currentMainTab}
      searchFilters={searchFilters}
      yoyLengthFilter={yoYLength}
    />
  </CustomAccordion>
}

export default YearOverYearDropdown;